<template>
    <div>
        <div class="group shadow mb-6 text-grey-darkest leading-normal rounded">
            <div class="flex items-top p-3 md:p-6 bg-white rounded-t">
                <img src="/static/img/ic_emergency.png" class="mr-2 w-10 h-10 md:w-12 md:h-12" />
                <div class="ml-4">
                    <div class="flex md:mb-1">
                        <span class="icon mr-2 md:text-lg text-grey-darkest"><i class="mdi mdi-clock"></i></span>
                        <span class="text-grey-darkest font-semibold text-sm md:text-base">{{ $t('Waiting_list') }}</span>
                    </div>
                    <div class="flex md:mb-1">
                        <span class="icon mr-2 text-lg text-red-light"><i class="mdi mdi-map-marker"></i></span>
                        <span class="text-sm md:text-base">
                            {{ emergency.zipCode }} {{ emergency.locality }}
                        </span>
                    </div>
                    <div class="flex">
                        <span class="icon mr-2 text-lg text-grey"><i class="mdi mdi-briefcase"></i></span>
                        <span class="text-sm md:text-base">{{ $t('type_' + emergency.type) }}</span>
                    </div>
                </div>
            </div>
            <div class="flex rounded-b py-3 px-2 justify-end items-center">
                <button @click.prevent="showDelete" class="text-blue hover:text-blue-dark uppercase tracking-wide font-semibold text-sm px-2">{{ $t('Delete_my_request') }}</button>
            </div>
        </div>

        <delete-emergency-modal :active="showDeleteModal" :emergency="emergency" @close="hideDelete" @deleted="deleted"></delete-emergency-modal>
    </div>
</template>
<script>
    import DeleteEmergencyModal from '@/components/Patient/DeleteEmergencyModal'

    export default {
        name: 'emergency-list-item',

        props: ['emergency'],

        components: {DeleteEmergencyModal},

        data () {
            return {
                showDeleteModal: false,
                step: 'details'
            }
        },

        methods: {
            showDelete () {
                this.showDeleteModal = true
            },

            hideDelete () {
                this.showDeleteModal = false
            },

            deleted () {
                this.$emit('deleted')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Patient/EmergencyListItem.vue